module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bidsData"
    }
  }, [_c('HeadControl', {
    ref: "HeadControl",
    attrs: {
      "titleName": '招标数据'
    },
    on: {
      "changeVal": _vm.changeVal,
      "changDate": _vm.changDate,
      "changePicker": _vm.changePicker
    }
  }), _vm._v(" "), (_vm.aggregation[0]) ? _c('div', {
    staticClass: "topBox"
  }, [_c('div', {
    staticClass: "DataBox"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "color": "#666666"
    }
  }, [_vm._v("投标个数")]), _vm._v(" "), _c('div', {
    staticClass: "smBox",
    staticStyle: {
      "margin-top": "0.1rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.26rem",
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.aggregation[0].count)), _c('span', {
    staticStyle: {
      "font-size": "0.12rem"
    }
  }, [_vm._v("个")])]), _vm._v(" "), _c('div', {
    staticClass: "imgBox",
    staticStyle: {
      "width": "0.56rem",
      "height": "0.55rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.aggregation[0].itemIcon,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "DataBox"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "color": "#666666"
    }
  }, [_vm._v("投标人数")]), _vm._v(" "), _c('div', {
    staticClass: "smBox",
    staticStyle: {
      "margin-top": "0.1rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.26rem",
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.aggregation[1].totalCount)), _c('span', {
    staticStyle: {
      "font-size": "0.12rem"
    }
  }, [_vm._v("人")])]), _vm._v(" "), _c('div', {
    staticClass: "imgBox",
    staticStyle: {
      "width": "0.56rem",
      "height": "0.55rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.aggregation[1].itemIcon,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "DataBox"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "color": "#666666"
    }
  }, [_vm._v("中标个数")]), _vm._v(" "), _c('div', {
    staticClass: "smBox",
    staticStyle: {
      "margin-top": "0.1rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.26rem",
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.aggregation[2].count)), _c('span', {
    staticStyle: {
      "font-size": "0.12rem"
    }
  }, [_vm._v("个")])]), _vm._v(" "), _c('div', {
    staticClass: "imgBox",
    staticStyle: {
      "width": "0.56rem",
      "height": "0.55rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.aggregation[2].itemIcon,
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "DataBox"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.16rem",
      "color": "#666666"
    }
  }, [_vm._v("中标人数")]), _vm._v(" "), _c('div', {
    staticClass: "smBox",
    staticStyle: {
      "margin-top": "0.1rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.26rem",
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.aggregation[3].totalCount)), _c('span', {
    staticStyle: {
      "font-size": "0.12rem"
    }
  }, [_vm._v("人")])]), _vm._v(" "), _c('div', {
    staticClass: "imgBox",
    staticStyle: {
      "width": "0.56rem",
      "height": "0.55rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.aggregation[3].itemIcon,
      "alt": ""
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "BigCenterBox"
  }, [_c('div', {
    staticClass: "centerBox"
  }, [_c('div', {
    ref: "bidsDataEcharts",
    attrs: {
      "id": "bidsDataEcharts"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "BigBottomBox"
  }, [_c('div', {
    staticClass: "BottomBox"
  }, [_c('div', {
    ref: "ChinaMap",
    attrs: {
      "id": "ChinaMap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Ranking"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "tablist"
  }, [_c('li', {
    class: {
      'active': _vm.activeProjectName === 'BID'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick('BID')
      }
    }
  }, [_vm._v("投标个数排行")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeProjectName === 'BIDDING'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick('BIDDING')
      }
    }
  }, [_vm._v("中标个数排行")])]), _vm._v(" "), (_vm.RankingDataList.length && _vm.activeProjectName === 'BID') ? _c('div', {
    attrs: {
      "id": "S-dataSort"
    }
  }, [_c('div', {
    staticClass: "bottom-Data"
  }, [_c('table', {
    staticClass: "table-Box"
  }, [_c('tr', {
    staticClass: "herader-Box"
  }, [_c('td', {
    attrs: {
      "width": _vm.screenWidth <= 1366 ? 180 : 300
    }
  }, [_vm._v("省份")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "180",
      "align": "center"
    }
  }, [_vm._v("投标人数（人）")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": _vm.identification == 'pplet' ? 160 : 140,
      "align": "center"
    }
  }, [_vm._v("投标个数（个）")])]), _vm._v(" "), _vm._l((_vm.RankingDataList), function(item, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "height": "32"
      }
    }, [_c('td', [_c('div', {
      staticClass: "dataBox"
    }, [_c('span', {
      class: {
        'red': item.serialNumber == '1',
        'orange': item.serialNumber == '2',
        'yellow': item.serialNumber == '3'
      },
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(item.serialNumber))]), _vm._v(_vm._s(item.province) + "\n                                  ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.totalCount))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.count))])])
  })], 2)])]) : (_vm.RankingDataList.length && _vm.activeProjectName === 'BIDDING') ? _c('div', {
    attrs: {
      "id": "S-dataSort"
    }
  }, [_c('div', {
    staticClass: "bottom-Data"
  }, [_c('table', {
    staticClass: "table-Box"
  }, [_c('tr', {
    staticClass: "herader-Box"
  }, [_c('td', {
    attrs: {
      "width": _vm.screenWidth <= 1366 ? 180 : 300
    }
  }, [_vm._v("省份")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "180",
      "align": "center"
    }
  }, [_vm._v("中标人数（人）")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": _vm.identification == 'pplet' ? 160 : 140,
      "align": "center"
    }
  }, [_vm._v("中标个数（个）")])]), _vm._v(" "), _vm._l((_vm.RankingDataList), function(item, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "height": "32"
      }
    }, [_c('td', [_c('div', {
      staticClass: "dataBox"
    }, [_c('span', {
      class: {
        'red': item.serialNumber == '1',
        'orange': item.serialNumber == '2',
        'yellow': item.serialNumber == '3'
      },
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(item.serialNumber))]), _vm._v(_vm._s(item.province) + "\n                                  ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.totalCount))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.count))])])
  })], 2)])]) : _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-Name"
  }, [_c('i', {
    staticClass: "el-icon-s-data"
  }), _vm._v(" "), _c('p', {
    staticClass: "titleName"
  }, [_vm._v("TOP10 省份投/中标数量排行")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d208be4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operationData/bidsData.vue
// module id = 1643
// module chunks = 471